import {
  Assessment,
  BarChartOutlined,
  Dashboard,
  Description,
  Group,
  Receipt,
  TableChart,
  TrendingUp,
  WaterfallChart,
} from '@mui/icons-material';
import { WATERFALL_SLUG, WATERFALL_TITLE } from 'common/constants/allocations';
import { BREAKPOINT_ANALYSIS_SLUG, BREAKPOINT_ANALYSIS_TITLE, CAP_TABLE_SIDEBAR_TITLE, CAP_TABLE_SLUG, CASH_FLOW_LEDGER_SLUG, CASH_FLOW_LEDGER_TITLE, FUND_OWNERSHIP_SLUG, FUND_OWNERSHIP_TITLE } from 'common/constants/cap-table';
import { COMPANIES_SUMMARY_SLUG, COMPANIES_SUMMARY_TITLE } from 'common/constants/companies';
import { DOCUMENTS_SLUG, DOCUMENTS_TITLE } from 'common/constants/documents';
import { FINANCIAL_SLUG, FINANCIAL_TITLE } from 'common/constants/financials';
import { VALUATIONS_SLUG, VALUATIONS_TAB_SLUG, VALUATIONS_TITLE } from 'common/constants/valuations';

export const BOTTOM_NAV_HEIGHT = 250;

export const COMPANY_PAGES = [
  {
    title: COMPANIES_SUMMARY_TITLE,
    slug: COMPANIES_SUMMARY_SLUG,
    tab: undefined,
    restrictProformas: false,
    icon: Dashboard,
  },
  {
    title: FINANCIAL_TITLE,
    slug: FINANCIAL_SLUG,
    tab: undefined,
    restrictProformas: false,
    icon: BarChartOutlined,
  },
  {
    title: CAP_TABLE_SIDEBAR_TITLE,
    slug: CAP_TABLE_SLUG,
    tab: CAP_TABLE_SLUG,
    restrictProformas: false,
    icon: TableChart,
  },
  {
    title: FUND_OWNERSHIP_TITLE,
    slug: CAP_TABLE_SLUG,
    tab: FUND_OWNERSHIP_SLUG,
    restrictProformas: false,
    icon: Group,
  },
  {
    title: BREAKPOINT_ANALYSIS_TITLE,
    slug: CAP_TABLE_SLUG,
    tab: BREAKPOINT_ANALYSIS_SLUG,
    restrictProformas: false,
    icon: TrendingUp,
  },
  {
    title: CASH_FLOW_LEDGER_TITLE,
    slug: CAP_TABLE_SLUG,
    tab: CASH_FLOW_LEDGER_SLUG,
    restrictProformas: true,
    icon: Receipt,
  },
  {
    title: VALUATIONS_TITLE,
    slug: VALUATIONS_SLUG,
    tab: VALUATIONS_TAB_SLUG,
    restrictProformas: false,
    icon: Assessment,
  },
  {
    title: WATERFALL_TITLE,
    slug: WATERFALL_SLUG,
    tab: undefined,
    restrictProformas: false,
    icon: WaterfallChart,
  },
  {
    title: DOCUMENTS_TITLE,
    slug: DOCUMENTS_SLUG,
    tab: undefined,
    restrictProformas: false,
    icon: Description,
  },
].map((value, index) => ({ ...value, id: index }));

export const PINNABLE_TYPES = {
  COMPANY: 'company',
  FUND: 'fund',
  FUND_INVESTMENT: 'fundInvestment',
  FIRM: 'firm',
};
